// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2iKc2","imageUploader":"EGiftCard_imageUploader__236xc"};